var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewGifts = function SvgNewGifts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 4.65c-.51 0-.85.51-.85.85v4.25h-1.7V5.5c0-.51-.34-.85-.85-.85s-.85.51-.85.85v4.25h-1.7V5.5c0-.51-.34-.85-.85-.85s-.85.51-.85.85v5.61c0 1.53 1.19 2.72 2.55 2.89v11.9c0 1.02.68 1.7 1.7 1.7s1.7-.68 1.7-1.7V14c1.36-.17 2.55-1.36 2.55-2.89V5.5c0-.34-.34-.85-.85-.85Zm3.4.85v10.2h1.7v10.2c0 1.02.68 1.7 1.7 1.7s1.7-.68 1.7-1.7V.4c-2.89 0-5.1 2.21-5.1 5.1Zm11.9-1.7c-2.38 0-4.25 2.55-4.25 5.61-.17 2.04.85 3.91 2.55 5.1V25.9c0 1.02.68 1.7 1.7 1.7s1.7-.68 1.7-1.7V14.51c1.7-1.19 2.72-3.06 2.55-5.1 0-3.06-1.87-5.61-4.25-5.61Z",
    fill: "#8E6F00"
  })));
};
export default SvgNewGifts;